//#region src/loyalty_signup_method.ts
let LoyaltySignupMethod = /* @__PURE__ */ function(LoyaltySignupMethod) {
	LoyaltySignupMethod["SMS"] = "sms";
	LoyaltySignupMethod["QR_CODE"] = "qr_code";
	return LoyaltySignupMethod;
}({});
//#endregion
export { LoyaltySignupMethod };

//# sourceMappingURL=loyalty_signup_method.js.map